import { z } from 'zod'

/**
 * Das Lagebild (Feature-Wunsch von Chris, 04.09.2026): die eine Frage, die man morgens hat —
 * *muss ich heute irgendwo ran?*
 *
 * Bewusst nur aus dem, was Kontor ohnehin schon weiß: offene Alarme, Verbindungszustände,
 * Backup-Läufe und der letzte Messpunkt. Kein einziger SSH-Aufruf. Eine Startseite, die bei
 * jedem Aufruf zehn Server abfragt, wäre nach dem dritten Mal die Seite, die man meidet.
 */
export const overviewSeveritySchema = z.enum(['error', 'warn'])
export type OverviewSeverity = z.infer<typeof overviewSeveritySchema>

export const overviewKindSchema = z.enum(['alert', 'connection', 'backup', 'disk'])
export type OverviewKind = z.infer<typeof overviewKindSchema>

export const overviewItemSchema = z.object({
  id: z.string(),
  severity: overviewSeveritySchema,
  kind: overviewKindSchema,
  title: z.string(),
  detail: z.string(),
  serverId: z.string().nullable(),
  serverName: z.string().nullable(),
  /** Wohin ein Klick führt — genau zu der Stelle, an der man das Problem anfasst. */
  href: z.string(),
  /** Seit wann, wenn bekannt. */
  at: z.iso.datetime().nullable(),
})
export type OverviewItem = z.infer<typeof overviewItemSchema>

export const overviewSchema = z.object({
  items: z.array(overviewItemSchema),
  checkedAt: z.iso.datetime(),
  serverCount: z.number().int().nonnegative(),
  connectedCount: z.number().int().nonnegative(),
  /** Wie viele Server gerade weder verbunden noch auffällig sind — reine Information. */
  idleCount: z.number().int().nonnegative(),
})
export type Overview = z.infer<typeof overviewSchema>

/**
 * Anzeigeschwellen für die Platte. Sie ersetzen keine Alarm-Regel — eine Regel meldet sich von
 * selbst, das Lagebild zeigt nur, was ohnehin schon gemessen wurde.
 */
export const OVERVIEW_DISK_WARN_PCT = 85
export const OVERVIEW_DISK_ERROR_PCT = 95
